module.exports = __webpack_public_path__ + "static/fonts/BMHANNA_11yrs_otf.otf?6040aeeb";